import React, { useState } from 'react';
import { CheckIcon, CreditCardIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function PricingSection() {
  const [includeColorimetria, setIncludeColorimetria] = useState(false);
  const basePrice = 19990;
  const basePriceOriginal = 49990;
  const colorimetriaPrice = 6990;
  const colorimetriaPriceOriginal = 26990;
  const totalPrice = includeColorimetria ? basePrice + colorimetriaPrice : basePrice;
  const totalPriceOriginal = includeColorimetria ? basePriceOriginal + colorimetriaPriceOriginal : basePriceOriginal;
  const discountPercentage = Math.round((totalPriceOriginal - totalPrice) / totalPriceOriginal * 100);
  const checkoutUrl = includeColorimetria ? 'https://checkout.tuvidasimple.shop/cart/44818150719590:1' : 'https://checkout.tuvidasimple.shop/cart/44818129059942:1';
  return <section id="pricing" className="w-full bg-[#0a0a0a] py-10 md:py-16 px-4" data-id="element-162">
      <div className="max-w-xl mx-auto" data-id="element-163">
        {/* Encabezado: Realidad del oficio */}
        <div className="text-center mb-8 md:mb-12" data-id="element-164">
          <h2 className="text-2xl md:text-4xl font-black text-white leading-tight mb-3" data-id="element-165">
            La barbería no es una moda.
          </h2>
          <p className="text-xl md:text-2xl font-black text-[#c41e3a] mb-6" data-id="element-166">
            Es un oficio con demanda constante.
          </p>

          <div className="bg-[#111] border border-gray-800 rounded-xl p-5 mb-6" data-id="element-167">
            <p className="text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-168">
              En muchas ciudades de Argentina, un corte puede cobrarse entre{' '}
              <strong className="text-white bg-[#c41e3a]/20 px-2 py-0.5 rounded" data-id="element-169">
                $10.000 y $20.000
              </strong>{' '}
              dependiendo del nivel y la zona.
            </p>
          </div>

          <p className="text-gray-400 text-sm md:text-base leading-relaxed mb-2" data-id="element-170">
            La diferencia entre un corte común y un corte profesional está en la
            técnica.
          </p>
          <p className="text-white font-black text-base md:text-lg" data-id="element-171">
            Y la técnica se aprende con método.
          </p>
        </div>

        <div className="bg-[#111] rounded-2xl border-2 border-[#c41e3a] shadow-2xl overflow-hidden" data-id="element-172">
          {/* Precio — punto focal */}
          <div className="bg-[#c41e3a]/10 border-b border-[#c41e3a]/30 p-6 md:p-8 text-center" data-id="element-173">
            <h3 className="text-xl md:text-2xl font-black text-white mb-2" data-id="element-174">
              Acceso completo a la formación
            </h3>
            <p className="text-gray-400 text-sm font-semibold mb-6" data-id="element-175">
              Incluye todas las clases en video + manual completo del método.
            </p>

            <div className="inline-block bg-[#c41e3a] text-white px-5 py-1.5 rounded-full font-black text-sm md:text-base mb-4 tracking-wide" data-id="element-176">
              🔥 Inversión única
            </div>

            <div className="mb-1" data-id="element-177">
              <span className="text-lg md:text-2xl text-gray-500 line-through font-bold" data-id="element-178">
                ${totalPriceOriginal.toLocaleString('es-AR')} ARS
              </span>
            </div>
            <div className="flex items-baseline justify-center gap-2 mb-3" data-id="element-179">
              <span className="text-5xl md:text-7xl font-black text-white" data-id="element-180">
                ${totalPrice.toLocaleString('es-AR')}
              </span>
              <span className="text-xl md:text-2xl text-gray-400 font-bold" data-id="element-181">
                ARS
              </span>
            </div>

            <p className="text-[#25D366] text-sm md:text-base font-bold bg-[#25D366]/10 inline-block px-4 py-2 rounded-lg mt-2" data-id="element-182">
              Con solo 2 o 3 cortes bien cobrados podés recuperar la inversión.
            </p>
          </div>

          {/* Includes */}
          <div className="p-5 md:p-8 space-y-3 border-b border-gray-800" data-id="element-183">
            <p className="text-xs md:text-sm text-gray-400 font-black tracking-widest uppercase mb-3" data-id="element-184">
              Incluye:
            </p>
            {[{
            icon: <ZapIcon className="w-5 h-5 text-[#c41e3a]" data-id="element-185" />,
            text: 'Acceso inmediato al material completo'
          }, {
            icon: <CheckIcon className="w-5 h-5 text-[#c41e3a]" data-id="element-186" />,
            text: 'Clases en video paso a paso'
          }, {
            icon: <CheckIcon className="w-5 h-5 text-[#c41e3a]" data-id="element-187" />,
            text: 'Manual completo del método (PDF)'
          }, {
            icon: <CheckIcon className="w-5 h-5 text-[#c41e3a]" data-id="element-188" />,
            text: '3 Bonus exclusivos'
          }, {
            icon: <CheckIcon className="w-5 h-5 text-[#c41e3a]" data-id="element-189" />,
            text: 'Certificado digital al completar'
          }].map(({
            icon,
            text
          }) => <div key={text} className="flex items-center gap-3 text-gray-200" data-id="element-190">
                {icon}
                <span className="text-sm md:text-base font-semibold" data-id="element-191">
                  {text}
                </span>
              </div>)}
          </div>

          {/* Order Bump */}
          <div className="p-5 md:p-8 border-b border-gray-800" data-id="element-192">
            <label className="flex items-start gap-4 cursor-pointer group" data-id="element-193">
              <input type="checkbox" checked={includeColorimetria} onChange={e => setIncludeColorimetria(e.target.checked)} className="w-5 h-5 mt-0.5 rounded border-2 border-gray-500 text-[#c41e3a] focus:ring-2 focus:ring-[#c41e3a] cursor-pointer flex-shrink-0" aria-label="Agregar formación en Colorimetría" data-id="element-194" />
              <div className="flex-1" data-id="element-195">
                <span className="text-white text-sm md:text-base font-black block mb-1" data-id="element-196">
                  🎨 Sumar Colorimetría aplicada al pack
                </span>
                <span className="text-gray-400 text-xs md:text-sm block mb-2" data-id="element-197">
                  Aprendé a trabajar con color de forma profesional
                </span>
                <div className="flex items-center gap-2" data-id="element-198">
                  <span className="text-gray-500 line-through text-sm font-semibold" data-id="element-199">
                    ${colorimetriaPriceOriginal.toLocaleString('es-AR')}
                  </span>
                  <span className="text-[#c41e3a] font-black text-lg" data-id="element-200">
                    +${colorimetriaPrice.toLocaleString('es-AR')}
                  </span>
                </div>
              </div>
            </label>
          </div>

          {/* CTA */}
          <div className="p-5 md:p-8" data-id="element-201">
            <p className="text-gray-400 text-center text-sm font-semibold mb-4" data-id="element-202">
              Después, todo depende de tu nivel y práctica.
            </p>
            <a href={checkoutUrl} target="_self" rel="noopener" className="cta-primary block w-full text-white font-black text-base md:text-xl py-4 md:py-5 rounded-xl text-center no-underline mb-3" aria-label="Acceder a la formación ahora" data-id="element-203">
              👉 QUIERO ACCEDER A LA FORMACIÓN
            </a>
            <p className="text-gray-500 text-xs text-center mb-5 font-semibold" data-id="element-204">
              Acceso inmediato después del pago.
            </p>

            <div className="flex items-center justify-center gap-4 text-gray-500 text-xs mb-5" data-id="element-205">
              <div className="flex items-center gap-1" data-id="element-206">
                <CreditCardIcon className="w-4 h-4" data-id="element-207" />
                <span data-id="element-208">Mercado Pago</span>
              </div>
              <span data-id="element-209">·</span>
              <div className="flex items-center gap-1" data-id="element-210">
                <ShieldCheckIcon className="w-4 h-4" data-id="element-211" />
                <span data-id="element-212">Compra segura</span>
              </div>
              <span data-id="element-213">·</span>
              <div className="flex items-center gap-1" data-id="element-214">
                <ZapIcon className="w-4 h-4" data-id="element-215" />
                <span data-id="element-216">Acceso inmediato</span>
              </div>
            </div>

            {/* Soporte WhatsApp */}
            <a href="https://wa.link/w7hdgn" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-[#25D366]/10 border border-[#25D366]/30 hover:border-[#25D366] rounded-lg px-4 py-3 transition-all mb-4 no-underline group" data-id="element-217">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 text-[#25D366] flex-shrink-0" aria-hidden="true" data-id="element-218">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-219" />
              </svg>
              <span className="text-[#25D366] text-xs md:text-sm font-semibold group-hover:text-[#1ebe5d] transition-colors" data-id="element-220">
                💬 ¿Tuviste algún problema con el pago o con el acceso?
                Escribinos y te ayudamos en minutos
              </span>
            </a>

            {/* Disclaimer producto digital */}
            <p className="text-gray-600 text-[11px] text-center leading-relaxed" data-id="element-221">
              Producto digital – acceso inmediato.
              <br data-id="element-222" />
              El acceso se envía automáticamente por email luego del pago.
              <br data-id="element-223" />
              No se envían productos físicos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}